module.exports = __webpack_public_path__ + "img/2.e66d0e81.png";